<template>
  <main class="AccountDeletedPage">
    <FormRequestAccountDeletion class="div1" />
    <article class="div2">
      <picture>
        <!-- <source
          type="image/webp"
          srcset="~@/assets/deletedAccount/delete_img.webp"
        /> -->
        <img src="~@/assets/deletedAccount/deleteaccount_img.png" />
      </picture>
    </article>
  </main>
</template>

<script>
import FormRequestAccountDeletion from '../components/AccountDeletionPage/FormRequestAccountDeletion.vue';

export default {
  components: { FormRequestAccountDeletion },
};
</script>

<style scoped>
.AccountDeletedPage {
  --page-text-color: #2b4047;
  padding-top: 76px;
  display: block;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.div1 {
  grid-area: 1;
}
.div2 {
  display: block;
  padding-top: 10vh;
}

.div2 picture img {
  margin: auto;
  display: block;
  padding-top: 0vh;
  width: 70%;
}

/*
  ======================
         DESKTOP
  ======================
  */

@media (min-width: 1024px) {
  .AccountDeletedPage {
    --page-text-color: #2b4047;
    padding-top: 76px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    margin-left: 10vh;
    margin-right: 10vh;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 3;
  }
  .div2 {
    grid-area: 1 / 3 / 2 / 4;
    display: block;
  }
  .div2 picture img {
    margin: unset;
  }
}
</style>
